module.exports = __webpack_public_path__ + "static/media/registrationIcon.ffcf7912.svg";